export default __webpack_public_path__ + "static/media/photo--sm--group-1.aa8b6a9d.jpg";